import { render } from "./IncludedService.vue?vue&type=template&id=02dbb722"
import script from "./IncludedService.vue?vue&type=script&lang=js"
export * from "./IncludedService.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__